if(!customElements.get('brands-slider')) {
  customElements.define(
    'brands-slider',
    class BrandsSlicer extends HTMLElement {
      sliderEl = undefined;
      sliderPaginationEl = undefined;
      sliderInstance = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('.slider');
        this.mount();
      }

      mount() {
        if(!this.sliderEl) {
          return console.error("[Brands Section] No slider element found!")
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          loop: true,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          speed: 3000,
          slidesPerView: 2,
          spaceBetween: 24,
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 48,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 56
            }
          }
        });
      }

      get slider() {
        return this.sliderInstance;
      }
    }
  )
}


